import { selectCurrentHotelId } from 'accessors'
import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import FilePreview from 'components/ReusableComponents/Messaging/ConversationBubble/FilePreview'
import Left from 'features/ManageCampaigns/RecentMediaDialog/Left'
import Right from 'features/ManageCampaigns/RecentMediaDialog/Right'
import { getImgUrlFromCDN } from 'features/ManageCampaigns/utils/campaignHelpers'
import useEsc from 'hooks/useEsc'
import useFirstRender from 'hooks/useFirstRender'
import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import styles from './RecentMediaDialog.module.scss'

const thumbnailWidth = 80
const thumbnailCountHorizontal = 10

const RecentMediaDialog = ({
  setSelectedMedia,
  recentFiles,
  handleHideDialog,
  getMoreMedia,
  hasAllFiles,
  mediaTag
}) => {
  const [activeFile, setActiveFile] = useState(Object.values(recentFiles)[0])

  const hotelId = useSelector(selectCurrentHotelId)

  const getImgUrl = fileName => getImgUrlFromCDN(fileName, mediaTag, hotelId)

  const [isNextDisabled, setIsNextDisabled] = useState(false)

  const [isPrevDisabled, setIsPrevDisabled] = useState(true)

  useEsc(handleHideDialog)

  const ref = useRef()

  useFirstRender(() => {
    const elem = ref.current

    if (Math.abs(elem.scrollLeft + elem.clientWidth - elem.scrollWidth) < 20) {
      getMoreMedia()
    }

    if (Object.values(recentFiles).length < 10) {
      setIsNextDisabled(true)
    }
  }, [])

  useEffect(() => {
    const elem = ref.current

    if (
      hasAllFiles &&
      Math.abs(elem.scrollLeft + elem.clientWidth - elem.scrollWidth) < 20
    ) {
      setIsNextDisabled(true)
    }
  }, [recentFiles, hasAllFiles])

  function scrollToRight() {
    const elem = ref.current

    setIsPrevDisabled(false)

    elem.scrollBy(thumbnailWidth * thumbnailCountHorizontal, 0)

    setTimeout(() => {
      if (hasAllFiles && elem.scrollLeft >= elem.scrollWidth - elem.offsetWidth) {
        setIsNextDisabled(true)
      }
    }, 500)

    if (Math.abs(elem.scrollLeft + elem.clientWidth * 2 - elem.scrollWidth) < 20) {
      getMoreMedia()
    }
  }

  function scrollToLeft() {
    ref.current.scrollBy(-thumbnailWidth * thumbnailCountHorizontal, 0)
  }

  function handleConfirm() {
    setSelectedMedia(activeFile.fileName)
    handleHideDialog(true)
  }

  return (
    <ConfirmationDialog
      maxWidth={862}
      hasHeader={false}
      negativeMessage="Cancel"
      positiveMessage="Use this file"
      onConfirm={handleConfirm}
      onReject={handleHideDialog}
      contentPadding={0}
    >
      <div className={styles.imgHolder}>
        <p className={styles.fileName}>{activeFile.fileName}</p>
        {activeFile.tags.contentType.includes('image') ? (
          <div
            className={styles.img}
            style={{
              backgroundImage: `url('${getImgUrl(activeFile.fileName)}') `,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'contain',
              backgroundPosition: 'center center'
            }}
          ></div>
        ) : (
          <p className={styles.noPreviewText}>No preview</p>
        )}
      </div>
      <div className={styles.controls}></div>
      <div className={styles.thumbnailWrapper}>
        <button
          onClick={scrollToLeft}
          className={styles.prev}
          disabled={isPrevDisabled}
          style={{ opacity: isPrevDisabled ? 0.2 : 1 }}
        >
          <Left width={20} height={30} />
        </button>
        <div className={styles.thumbnailHolder} ref={ref}>
          {Object.values(recentFiles).map(file => (
            <>
              <div
                className={styles.thumbnail}
                onClick={() => setActiveFile(file)}
                style={{
                  border:
                    file.fileName === activeFile.fileName
                      ? '2px solid var(--linkBlue)'
                      : '2px solid transparent'
                }}
                key={file.fileName}
              >
                <div className={styles.fileHolder}>
                  <FilePreview
                    extension={file.fileName.match(/\.(\w+)$/)[1]}
                    src={getImgUrlFromCDN(file.fileName, mediaTag, hotelId)}
                    clickable={false}
                    className={styles.thumbnailInner}
                  />
                  <span className={styles.fileNameInner}>
                    {file.fileName.replace(/\d{14}__swaypay__/, '')}
                  </span>
                </div>
              </div>
            </>
          ))}
        </div>
        <button
          onClick={scrollToRight}
          className={styles.next}
          disabled={isNextDisabled}
          style={{ opacity: isNextDisabled ? 0.2 : 1 }}
        >
          <Right width={20} height={30} />
        </button>
      </div>
    </ConfirmationDialog>
  )
}

export default RecentMediaDialog
